import { Avatar, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PeopleIcon from '@mui/icons-material/People';
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from 'react';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { getInitials } from '../../../../utils/helper';
import DoneIcon from '@mui/icons-material/Done';
import PersonIcon from '@mui/icons-material/Person';
import { RespType } from '../../../../config/kanban';

const CardMenu = ({
  handleClose,
  menuPosition,
  open,
  getItemById,
  handleDeleteTask,
  autoCompleteData,
  addOrRemoveRespPerson,
  currentTask,
  updateRespPerson,
}) => {
  const defSubItem = {
    target: null,
    onClick: () => {},
    type: '',
  };
  const [subItemOpen, setSubItemOpen] = useState(defSubItem);

  const handleOpenSubMenu = (data) => {
    setSubItemOpen(data);
  };

  const handleCloseSubMenu = () => {
    setSubItemOpen(defSubItem);
  };

  return (
    <>
      <Menu
        id="basic-menu"
        open={open}
        onClose={() => {
          handleClose();
          handleCloseSubMenu();
        }}
        anchorReference="anchorPosition"
        anchorPosition={Boolean(menuPosition) ? { top: menuPosition.mouseY, left: menuPosition.mouseX } : undefined}
      >
        <MenuItem onClick={getItemById} onMouseEnter={handleCloseSubMenu}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Szerkesztés</ListItemText>
        </MenuItem>
        <MenuItem
          onMouseEnter={(e) =>
            handleOpenSubMenu({
              target: e.currentTarget,
              onClick: (userId) => updateRespPerson(userId),
              type: RespType.CHIEF,
            })
          }
        >
          <ListItemIcon>
            <PersonIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Fő felelős</ListItemText>
          <ArrowRightIcon fontSize="small" />
        </MenuItem>
        <MenuItem
          onMouseEnter={(e) =>
            handleOpenSubMenu({
              target: e.currentTarget,
              onClick: (userId) => addOrRemoveRespPerson(userId),
              type: RespType.OTHER,
            })
          }
        >
          <ListItemIcon>
            <PeopleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>További felelősök</ListItemText>
          <ArrowRightIcon fontSize="small" />
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleDeleteTask} onMouseEnter={handleCloseSubMenu}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Törlés</ListItemText>
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={subItemOpen.target}
        open={Boolean(subItemOpen.target)}
        onClose={handleCloseSubMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        sx={{ pointerEvents: 'none' }}
        MenuListProps={{
          sx: { pointerEvents: 'auto' },
          onMouseLeave: handleCloseSubMenu,
        }}
      >
        <Typography fontSize="large" textAlign="center" my={1}>
          {subItemOpen.type === RespType.CHIEF ? 'Fő felelős' : 'További felelősök'}
        </Typography>
        {autoCompleteData?.user?.map((u) => {
          const isChecked =
            subItemOpen.type === RespType.CHIEF
              ? currentTask?.resposiblePersonId === u.userId
              : currentTask?.simpleTaskRespPersonlist?.some((p) => p.userId === u.userId);

          const sendingUserId = subItemOpen.type === RespType.CHIEF && isChecked ? null : u.userId;

          return (
            <MenuItem key={u.userId} onClick={() => subItemOpen.onClick(sendingUserId)}>
              <ListItemIcon>{isChecked && <DoneIcon fontSize="small" />}</ListItemIcon>
              <Avatar sx={{ bgcolor: u?.color || '#F9BC04', width: 30, height: 30, fontSize: '1rem', mr: 2 }}>
                {getInitials(u?.nickName)}
              </Avatar>
              <ListItemText>{u?.nickName}</ListItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default CardMenu;
